import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import { useNavigate } from "react-router-dom";

import aboutHero from "../assets/hikkaduwa-2.jpg";

import bus from "../assets/bus.png";

import pkg1 from "../assets/polonnaruwa-1.jpg";
import pkg2 from "../assets/place21.jpg";
import pkg3 from "../assets/place18.jpg";
import pkg4 from "../assets/jaffna-1.jpg";

function TourPackages() {

    useEffect(() => {
        AOS.init({ duration: 800, once: true });
    }, []);

    const navigate = useNavigate();

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${aboutHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center text-white">
                    <h1 className="mb-4 text-4xl font-extrabold sm:text-5xl md:text-6xl">
                        Tour Packages
                    </h1>
                    <p className="max-w-2xl text-sm text-gray-200 sm:text-base">
                        Reliable Taxi & Tour Services Across Sri Lanka
                    </p>
                </div>
            </section>

            {/* ================= TOUR PACKAGES SECTION ================= */}
            <section className="py-16 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">

                        {[
                            {
                                title: "Culture Heritage Tour",
                                desc: "The 'Culture Heritage Tour' tour package typically includes visits to historically and culturally significant locations in Sri Lanka.",
                                img: pkg1,
                                slug: "culture-heritage-tour",
                            },
                            {
                                title: "Nature & Adventure Tour",
                                desc: "The 'Nature & Adventure Tour' tour package offers an authentic eco-adventure in Sri Lanka, combining nature, culture, and thrilling experiences.",
                                img: pkg2,
                                slug: "nature-and-adventure-tour",
                            },
                            {
                                title: "Coastal & Beach Tour",
                                desc: "The 'Coastal & Beach Tour' tour package typically includes visits to historically and culturally significant locations in Sri Lanka.",
                                img: pkg3,
                                slug: "coastal-and-beach-tour",
                            },
                            {
                                title: "Ramayana Tour",
                                desc: "The 'Ramayana Tour' tour package typically includes visits to historically and spiritually significant locations in Sri Lanka, offering an immersive experience into the epic Ramayana's deep-rooted connection with the island.",
                                img: pkg4,
                                slug: "ramayana-tour",
                            },
                        ].map((tour, index) => (
                            <div
                                key={index}
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                                className="bg-white rounded-xl shadow-md overflow-hidden transition hover:shadow-xl"
                            >
                                {/* Image */}
                                <div className="overflow-hidden">
                                    <img
                                        src={tour.img}
                                        alt={tour.title}
                                        className="w-full h-56 object-cover transition duration-500 hover:scale-105"
                                    />
                                </div>

                                {/* Content */}
                                <div className="p-6">
                                    <h3 className="text-lg font-semibold text-gray-900">
                                        {tour.title}
                                    </h3>

                                    <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                                        {tour.desc}
                                    </p>

                                    <button
                                        onClick={() => navigate(`/tour-packages/${tour.slug}`)}
                                        className="mt-4 text-teal-600 font-medium hover:underline"
                                    >
                                        Read More »
                                    </button>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            </section>

            {/* ================= TAXI CTA ================= */}
            <section className="w-full bg-[#f7f7f7] py-16">
                <div className="mx-auto max-w-7xl px-4 grid md:grid-cols-2 gap-10 items-center">

                    <div className="text-center">
                        <h2 className="mb-4 text-3xl font-extrabold">Book your Taxi Today!</h2>
                        <p className="mb-6 text-gray-700">
                            RNR Travels & Tours is the best and no.1 Taxi & Tour service provider in Sri Lanka.
                        </p>
                        <p className="mb-6 text-2xl font-bold">+94 76 924 5905</p>
                        <a href="tel:+94743205692" className="inline-block rounded bg-black px-8 py-3 text-yellow-400">
                            Contact Us
                        </a>
                    </div>

                    <div className="flex justify-center">
                        <img src={bus} alt="Taxi Service" />
                    </div>

                </div>
            </section>

            <a
                href="https://wa.me/94769245905"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src={require("../assets/whatsapp.png")}
                    alt="WhatsApp Icon"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default TourPackages;